
import { getEdgeFunctionUrl } from '@/utils/supabaseUrl';

/**
 * Generate the correct webhook URL based on the current Supabase configuration
 */
export const generateWebhookUrl = (): string => {
  return getEdgeFunctionUrl('telegram-bot');
};

/**
 * Clear all cached webhook URLs from localStorage
 */
export const clearWebhookCache = (): void => {
  localStorage.removeItem('telegram_webhook_url');
  localStorage.removeItem('webhook_url_key');
  // Clear any other webhook-related cache keys
  Object.keys(localStorage).forEach(key => {
    if (key.toLowerCase().includes('webhook') || key.toLowerCase().includes('telegram_url')) {
      localStorage.removeItem(key);
    }
  });
};

/**
 * Check if the current webhook URL matches the expected project
 */
export const isWebhookUrlValid = (currentUrl: string): boolean => {
  try {
    const expectedUrl = generateWebhookUrl();
    return currentUrl === expectedUrl;
  } catch {
    return false;
  }
};
